import { Component, inject, Injector, OnInit, ViewChild } from '@angular/core';
import { jkGlb, login, MaterialModule } from 'jk-service';

import { FormsModule } from '@angular/forms';
import { jkBaseForm } from 'jk-service';
import { HomeHeaderComponent, HomeBottomComponent, HomeService } from 'jk-service';
import { JkmenuComponent } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { RouterLink } from '@angular/router';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    HomeHeaderComponent,
    FormsModule,
    JkmenuComponent,
    HomeBottomComponent
],
  templateUrl: './stock-home.component.html',
  styleUrl: './home.component.css'
})
export class StockHomeComponent extends jkBaseForm implements OnInit {
  override _programId = 'home'; //###
  //versionCheck = inject(VersionCheckService);
  home = inject(HomeService);
  myPages = jkGlb.pages;

  doMenu(id: string) {
    this.home.doMenu(this.router, id);
  }
  showMenu: boolean = true; // ###
  //opened: boolean = false;
  constructor() {
    const injector = inject(Injector);
    super(injector);
    this.home.init(jkGlb.pages);//###
    //jkGlb.pages = appPages;
    let homeTitle = '';
    if (jkGlb.env)
      homeTitle = jkGlb.env.title + ' 版本: ' + jkGlb.env.version
    else
      homeTitle = '傑克股票系統(無jkglb.env)';
    this.title = homeTitle;
    this.setFormOpt2(this.title); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    await super.ngAfterViewInit();

    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
    //this.stockSrv.init(false, Login.uid);
    if (!login.isLogin) {
      this.navigateTo('/login-form');
    }
  }
  override doComReady($event: HomeHeaderComponent, comName: string) {
    super.doComReady($event, comName);
    if (this.homeHeader)
      this.homeHeader.cbLeftMenu = this.onLeftMenu.bind(this);
  }
  onLeftMenu() {
    this.showMenu = !this.showMenu;
    //if(this.leftMenu)
    //  this.leftMenu.openMenu();
  }

}
